import React, { useState } from "react";
import {InputPrice} from "./form/InputPrice";

const EditablePriceCell = React.memo(({ value: initialValue, onSave }) => {
    const [value, setValue] = useState(initialValue);

    const handleBlur = () => {
        if (value !== initialValue) {
            onSave(value);
        }
    };

    return (
        <InputPrice
            value={value}
    setter={(val) => setValue(val)}
    onBlur={handleBlur}/>
);
});

export default EditablePriceCell;